import uni from "../styles/univesal.module.css";
import { logo } from "./common";
import { LangIds, Languages, getLang } from "../langs/langs";
import Lottie from "lottie-react";
import lottie_turn from "../animations/turn_card.json";

interface Props {
  lang: Languages;
  onAccept: () => void;
}

function TurnDoc({lang, onAccept}: Props) {
  return (
    <>
    <div className={uni.container}>
      <div className={uni.bigText}>{getLang(LangIds.TURN_Doc, lang)}</div>
      <div className={uni.spacerBig}/>
      <div className={uni.center}>
      <Lottie className={uni.animationContainerBig} animationData={lottie_turn}/>
      </div>
      <div className={uni.filler}/>
      <button className={uni.button} type="button" onClick={onAccept}>{getLang(LangIds.BUTTON_Continue, lang)}</button>
      {logo(getLang(LangIds.LOGO_Powered, lang))}
    </div>
    </>
  );
}

export default TurnDoc;
